var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 12.4184 3.5816 16 8 16C12.4184 16 16 12.4184 16 8C16 3.5816 12.4184 0 8 0C3.5816 0 0 3.5816 0 8ZM7.2636 6.9636C7.43239 6.79482 7.6613 6.7 7.9 6.7C8.13869 6.7 8.36761 6.79482 8.5364 6.9636C8.70518 7.13239 8.8 7.3613 8.8 7.6V11.2C8.8 11.4387 8.70518 11.6676 8.5364 11.8364C8.36761 12.0052 8.13869 12.1 7.9 12.1C7.6613 12.1 7.43239 12.0052 7.2636 11.8364C7.09482 11.6676 7 11.4387 7 11.2V7.6C7 7.3613 7.09482 7.13239 7.2636 6.9636ZM7.39999 4.15168C7.54799 4.05278 7.722 4 7.9 4C8.13869 4 8.36761 4.09482 8.5364 4.2636C8.70518 4.43239 8.8 4.6613 8.8 4.9C8.8 5.078 8.74722 5.25201 8.64832 5.40001C8.54943 5.54802 8.40887 5.66337 8.24442 5.73149C8.07996 5.79961 7.899 5.81743 7.72442 5.78271C7.54984 5.74798 7.38947 5.66226 7.2636 5.5364C7.13774 5.41053 7.05202 5.25016 7.01729 5.07558C6.98257 4.901 7.00039 4.72004 7.06851 4.55558C7.13663 4.39113 7.25198 4.25057 7.39999 4.15168Z",
    fill: "#939CA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.fee17e65e77aa4426eaed97b4726b35f.svg";
export { ForwardRef as ReactComponent };